import Vue from 'vue';

import formatDate from 'date-fns/format';
import locale from 'date-fns/locale/ru';

Vue.filter('formatDateTime', (value) => {
  if (value) {
    if (typeof value === 'string') {
      value = new Date(value);
    }
    return formatDate(
      value,
      'dd.MM.yyyy, kk:mm:SS',
      { locale },
    );
  }
});
